import { combineReducers } from "redux";

// Front
import LayoutReducer from "./layouts/reducer";

// Authentication
import LoginReducer from "./auth/login/reducer";
import AccountReducer from "./auth/register/reducer";
import ForgetPasswordReducer from "./auth/forgetpwd/reducer";
import ProfileReducer from "./auth/profile/reducer";

// Dashboard CRM
import DashboardReducer from "./dashboard/reducer";

//ChatGPT
import ChatGPTReducer from "./chatgpt/reducer";

// Statistic
import StatisticReducer from "./statistic/reducer";

// Operator
import OperatorReducer from "./operator/reducer";

// User
import UserReducer from "./user/reducer";

import {
  UsersActiveReducer,
  UsersBartenderReducer,
  UsersManagerReducer,
} from "./user/reducer";

// Role
import RoleReducer from "./role/reducer";

// Global
import GlobalReducer from "./global/reducer";

import {
  FeedBatenderReducer,
  PostReducer,
  WallpaperReducer,
  WinkReducer,
} from "./post/reducer";

// User Admin
import AdminReducer from "./admin/reducer";

// User Log
import { FeedbackReducer } from "./feedback/reducer";

// Bar List
import BarListReducer from "./bar-list/reducer";

// Facility
import FacilityReducer from "./facility/reducer";

// Staff
import StaffReducer from "./staff/reducer";

// TimeWorkingReducer
import TimeWorkingReducer from "./time-working/reducer";
import { FoodDrinkReducer } from "./foodDrink/reducer";

// Package Sticker
import PackageStickerReducer from "./sticker/reducer";
import { ReservationReducer } from "./reservation/reducer";
import { BarTableReducer } from "./barTable/reducer";
import { PushNotiReducer } from "./pushNoti/reducer";

// Ads Management
import { AdsPlanReducer } from "./ads/reducer";

// Agency Management
import AgencyReducer from "./agency/reducer";
import AgencyCampaignReducer from "./agencyCampaign/reducer";
import AgencyTrackingLogReducer from "./agencyTrackingLog/reducer";

// Coupon Management
import CouponReducer from "./coupon/reducer";

import InquiryListReducer from "./inquiry-list/reducer";

// Push Notification
import PushNotification from "./push-notification/reducer";

// Location Log
import LocationLogReducer, {
  LocationLogNewReducer,
} from "./locationLog/reducer";
import EventLogReducer, { EventLogNewReducer } from "./eventLog/reducer";
import ChatLogReducer from "./chatLog/reducer";
import HashTagReducer from "./hashtag/reducer";

// Log
import LogReducer from "./logging/reducer";

// Referral Rules
import ReferralRuleReducer from "./referral-rule/reducer";

// Referral Reward
import ReferralRewardReducer from "./referral-rewards/reducer";

// Referral Reward
import ReferralTriggerEventReducer from "./referral-trigger-event/reducer";

// VOC Reason
import VOCReasonReducer from "./voc-reason/reducer";

// VOC List
import VOCListReducer from "./voc-list/reducer";

// Request Withdraw
import RequestWithdrawReducer from "./request-withdraw/reducer";

const rootReducer = combineReducers({
  Layout: LayoutReducer,
  Login: LoginReducer,
  Account: AccountReducer,
  ForgetPassword: ForgetPasswordReducer,
  Profile: ProfileReducer,
  Dashboard: DashboardReducer,
  ChatGPT: ChatGPTReducer,
  Statistic: StatisticReducer,
  User: UserReducer,
  Operator: OperatorReducer,
  UsersActive: UsersActiveReducer,
  UsersBartender: UsersBartenderReducer,
  UsersManager: UsersManagerReducer,

  Role: RoleReducer,
  Global: GlobalReducer,
  Post: PostReducer,
  Wallpaper: WallpaperReducer,
  Wink: WinkReducer,
  FeedBatender: FeedBatenderReducer,
  Admin: AdminReducer,
  Feedback: FeedbackReducer,

  BarList: BarListReducer,
  Facility: FacilityReducer,
  Staff: StaffReducer,
  TimeWorking: TimeWorkingReducer,

  FoodDrink: FoodDrinkReducer,

  PackageSticker: PackageStickerReducer,
  Reservation: ReservationReducer,

  BarTable: BarTableReducer,
  PushNoti: PushNotiReducer,
  AdsPlan: AdsPlanReducer,

  Agency: AgencyReducer,
  AgencyCampaign: AgencyCampaignReducer,
  AgencyTrackingLog: AgencyTrackingLogReducer,

  Coupon: CouponReducer,

  InquiryList: InquiryListReducer,

  PushNotification: PushNotification,

  LocationLog: LocationLogReducer,
  EventLog: EventLogReducer,
  ChatLog: ChatLogReducer,
  EventLogNew: EventLogNewReducer,
  LocationLogNew: LocationLogNewReducer,

  Log: LogReducer,

  HashTag: HashTagReducer,

  Rule: ReferralRuleReducer,
  Reward: ReferralRewardReducer,
  TriggerEvent: ReferralTriggerEventReducer,
  
  Withdraw: RequestWithdrawReducer,

  VOCReasons: VOCReasonReducer,
  VOCList: VOCListReducer,
});

export default rootReducer;
